/* eslint no-use-before-define: 0 */

const Action = name => ({
  name,
  callbacks: [],
  registerCallback(callback) {
    this.callbacks.push(callback);
  },
});

export default function PubSub() {
  const actions = {};

  function hasAction(name) {
    return Object.prototype.hasOwnProperty.call(actions, name);
  }

  function registerAction(name) {
    actions[name] = new Action(name);
  }

  function subscribe(name, callback) {
    if (!callback) {
      throw TypeError('Expected a callback as a 2nd argument');
    }

    if (!hasAction(name)) {
      registerAction(name);
    }

    actions[name].registerCallback(callback);

    return unsubscribe.bind(null, name, callback);
  }

  function unsubscribe(name, callback) {
    if (hasAction(name)) {
      const index = actions[name].callbacks.indexOf(callback);
      if (index >= 0) {
        actions[name].callbacks.splice(index, 1);
      }
    }
  }

  function publish(name, ...args) {
    if (hasAction(name)) {
      actions[name].callbacks.forEach(callback => {
        callback.apply(callback, args);
      });
    }
  }

  return { subscribe, unsubscribe, publish };
}
